// extracted by mini-css-extract-plugin
module.exports =  {"productsInfo":"productsInfo__oE4v9","row":"row__lJ1iJ","tip":"tip__wBKmf","title":"title__qe76S","info":"info__4XaOz","sub":"sub__fFs2J"};